import React, { Component } from 'react';
import './feedbackPopup.css';

class FeedbackPopup extends Component {
    constructor(props) {
        super(props);
        this.closePopup = this.closePopup.bind(this);
        this.state = {
            popupDisplay: "none"
        }
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps) {
        if (this.props !== prevProps) {
            this.setState({
                popupDisplay: "none"
            })
        }
    }

    closePopup(e) {
        this.setState({
            popupDisplay: "none"
        })
    }

    render() {
        return (
            <div className="modalOptions" style={{ display: this.state.popupDisplay }}>
                <div className="modalHeader">
                    <div className="modalTitle">
                        Thanks for your feedback
                    </div>
                    <i className="bi bi-x" onClick={this.closePopup}></i>
                </div>
                <div className="options">
                    <div className="option" title="Report a bug">
                        <i className="bi bi-bug"></i>
                        <div className="actionCall">
                            Bug
                        </div>
                    </div>
                    <div className="option" title="Request a Feature">
                        <i className="bi bi-plus-square"></i>
                        <div className="actionCall">
                            Feature
                        </div>
                    </div>
                    <div className="option" title="Leave a Comment">
                        <i className="bi bi-chat-dots"></i>
                        <div className="actionCall">
                            Comment
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FeedbackPopup;